
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameSlug]/articles",
      function () {
        return require("private-next-pages/[gameSlug]/articles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameSlug]/articles"])
      });
    }
  